import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { rethrowUnlessAbort } from "../../utils/fetch-error.util"

const FIELDS = ["customer_id", "reverse_charge", "auto_on_payment", "on_payment_autonomy"]

// Asks the server for the "Po prijatí platby" summary again whenever something it depends on changes: the
// customer (a document-level event), the reverse-charge switch, or one of the row's own radios. The words are
// the server's; this only keeps them current.
export default class extends Controller {
  static values = { url: String, id: String, delay: { type: Number, default: 200 } }

  #abortController = null
  #generation = 0
  #timer = null
  #onContact = () => this.#schedule()

  connect() {
    document.addEventListener("selectedContact", this.#onContact)
    this.element.closest("form")?.addEventListener("change", this.#onFormChange)
  }

  disconnect() {
    document.removeEventListener("selectedContact", this.#onContact)
    this.element.closest("form")?.removeEventListener("change", this.#onFormChange)
    clearTimeout(this.#timer)
    this.#abortController?.abort()
  }

  changed() {
    this.#schedule()
  }

  #onFormChange = (event) => {
    if (/\[(customer_id|reverse_charge)\]$/.test(event.target?.name || "")) this.#schedule()
  }

  #schedule() {
    clearTimeout(this.#timer)
    this.#timer = setTimeout(() => this.#refresh(), this.delayValue)
  }

  async #refresh() {
    this.#abortController?.abort()
    this.#abortController = new AbortController()
    const generation = ++this.#generation
    const { signal } = this.#abortController

    try {
      const response = await fetch(`${this.urlValue}?${this.#params()}`, {
        headers: { Accept: "text/vnd.turbo-stream.html" },
        signal
      })
      if (!response.ok) throw new Error(`on_payment_row ${response.status}`)
      const html = await response.text()
      if (generation !== this.#generation || !this.element.isConnected) return
      Turbo.renderStreamMessage(html)
    } catch (error) {
      rethrowUnlessAbort(error)
    }
  }

  #params() {
    const form = this.element.closest("form")
    const params = new URLSearchParams()
    if (this.idValue) params.set("id", this.idValue)
    if (!form) return params
    for (const [name, value] of new FormData(form)) {
      const field = FIELDS.find((candidate) => name.endsWith(`[${candidate}]`))
      if (field) params.set(field, value)
    }
    return params
  }
}
